import { actions as mainActions } from 'Core/redux/main/slice';

export const { setToogleHeader } = mainActions;
